import React, {PropTypes} from 'react';
import Button from '../../common/Button';
import '../../../styles/profile/profileForm.css';
import * as paths from '../../../constants/pathConstants';
import { browserHistory } from 'react-router';
const ProfileBasicInfo = ({user, startUpdate}) => {

  function handleButtonClick(event) {
    event.preventDefault();
    const path = event.target.name;
    browserHistory.push(path);
  }

  return (
    <div className="col-xs-12 col-sm-9" id="profile-panel">
      <div className="border-container col-xs-12">
        <div className="basic-info-header">
          <h2>
            Profile
          </h2>
          <div className="buttonDiv">
            <Button
              onClick={startUpdate}
              name={paths.accountPageBase + paths.pathToAccountEditPage}
              className="pull-right non-mobile"
              value="Update Profile"
              disabled={false}/>
            <Button 
              onClick={handleButtonClick}
              name={paths.pathToBulkTransferPage}
              className="pull-right non-mobile"
              value="Bulk Transfer Establishments"
              />
            </div>
        </div>
        <div className="basic-info-body">
          <div>
            <b>First Name: {}
            </b>{user.firstName}</div>
          <div>
            <b>Last Name: {}
            </b>{user.lastName}</div>
          <div>
            <b>Company Name: {}
            </b>{user.companyName}</div>
          <div>
            <b>Job Title: {}
            </b>{user.jobTitle}</div>
          <div>
            <b>Email Address: {}
            </b>{user.email}</div>
          <div>
            <b>Phone Number: {}
            </b>{user.phoneNumber}</div>
        </div>
        <div className="buttonDiv">
          <Button
            onClick={startUpdate}
            name={paths.accountPageBase + paths.pathToAccountEditPage}
            className="outlined-button pull-right mobile"
            value="Update Profile"
            disabled={false}/>
          <Button 
              onClick={handleButtonClick}
              name={paths.pathToBulkTransferPage}
              className="outlined-button pull-right mobile"
              value="Bulk Transfer Establishments"
              />
        </div>
      </div>
    </div>
  );
};

ProfileBasicInfo.propTypes = {
  user: PropTypes.object.isRequired,
  startUpdate: PropTypes.func.isRequired
};

export default ProfileBasicInfo;



/** WEBPACK FOOTER **
 ** ./src/components/account/manageAccount/ProfileBasicInfo.js
 **/